// extracted by mini-css-extract-plugin
export default {"footerWrapper":"MenuFooter_footerWrapper__M+Xwf"};